export default __webpack_public_path__ + "static/media/forgot-password.143789ca.png";